<template>
  <div>
    <!-- <v-row no-gutters>
      <v-col v-for="n in 3" :key="n" cols="12" sm="4">
        <v-card class="pa-2" outlined tile> One of three columns </v-card>
      </v-col>
    </v-row> -->
    <MeetingDetailsPage
      :selectedMeetingID="$route.params.id"
    ></MeetingDetailsPage>
    <!-- <v-app-bar
      app
      color="appMenu"
      dense
      class="fill-height"
      dark
      clipped-right
      height="32"
      fixed
    >
      <v-icon left> mdi-calendar-clock</v-icon>{{ selectedMeeting.meetingName }}
      <v-spacer></v-spacer>
    </v-app-bar> -->
    <!-- <v-container fluid>
      <v-row justify="center">
        <v-col cols="12">
          <MeetingDetailsPage       
            :selectedMeetingID="$route.params.id"                    
          ></MeetingDetailsPage>         
        </v-col>
      </v-row>
      <ConfirmDialog ref="confirm" />
    </v-container> -->
  </div>
</template>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
// @ is an alias to /src
import MeetingDetailsPage from "@/components/agenda/MeetingDetails.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import Vue from "vue";
Vue.prototype.$eventHub = new Vue();
export default {
  name: "Agenda",
  data() {
    return {
      selectedMeetingID: "",
    };
  },

  mounted() {
    // this.selectedMeetingID = this.$route.params.id;
    // alert(this.selectedMeetingID);
  },

  components: {
    MeetingDetailsPage,
    ConfirmDialog,
  },
  computed: {},
  async beforeRouteLeave(to, from, next) {
    //const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (false) {
      const answer = await this.ConfirmDelete();
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    async ConfirmDelete() {
      if (
        await this.$refs.confirm.open(
          this.$t("hUnsavedDataConfirmation"),
          this.$t("lblUnsavedDataMessage")
        )
      ) {
        return true;
      }
    },
  },
};
</script>
